module.exports = __webpack_public_path__ + "static/img/cCT4.e7e4bcd0.png";